import Alert, { type AlertColor, type AlertPropsColorOverrides } from "@mui/material/Alert";
import Slide, { type SlideProps } from '@mui/material/Slide';
import Snackbar from "@mui/material/Snackbar";
import { type OverridableStringUnion } from "@mui/types";
import { type ReactElement } from "react";

export interface ToastOptions {
    severity?: OverridableStringUnion<AlertColor, AlertPropsColorOverrides> | undefined;
    message: string;
}

interface ToastProps extends ToastOptions {
    open: boolean;
    onClose: () => void;
}

const Toast = ({ open, severity = "success", message, onClose }: ToastProps): ReactElement => {
    
    function SlideTransition(props: SlideProps) {
        return <Slide {...props} direction="up" />;
    }

    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            slots={{ transition: SlideTransition }}
        >
            <Alert
                severity={severity}
                variant="filled"
                sx={{ width: '100%' }}
                onClose={onClose}
            >
                {message}
            </Alert>
        </Snackbar>
    )
}

export default Toast;